const triggerLogin = () => {
  (document.querySelector(".js-switch-sign") as HTMLElement | null).click();
};

export { triggerLogin };
